// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lUwCc","col":"styles_col__2ngY8"};